/* tslint:disable */
/* eslint-disable */
/**
 * Risks API
 * API for managing risks.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UnemploymentSurveyResponse
 */
export interface UnemploymentSurveyResponse {
    /**
     * 
     * @type {boolean}
     * @memberof UnemploymentSurveyResponse
     */
    isEligible: boolean;
}

/**
 * Check if a given object implements the UnemploymentSurveyResponse interface.
 */
export function instanceOfUnemploymentSurveyResponse(value: object): value is UnemploymentSurveyResponse {
    if (!('isEligible' in value) || value['isEligible'] === undefined) return false;
    return true;
}

export function UnemploymentSurveyResponseFromJSON(json: any): UnemploymentSurveyResponse {
    return UnemploymentSurveyResponseFromJSONTyped(json, false);
}

export function UnemploymentSurveyResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UnemploymentSurveyResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'isEligible': json['isEligible'],
    };
}

export function UnemploymentSurveyResponseToJSON(json: any): UnemploymentSurveyResponse {
    return UnemploymentSurveyResponseToJSONTyped(json, false);
}

export function UnemploymentSurveyResponseToJSONTyped(value?: UnemploymentSurveyResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isEligible': value['isEligible'],
    };
}

